'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'trash-check';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2af';
var svgPathData = ['M76.9 144l294.3 0-22.6 305.2c-.6 8.4-7.6 14.8-16 14.8l-217.1 0c-8.4 0-15.3-6.5-16-14.8L76.9 144zm73.9 178.2l35.9 37.2c4.9 5.1 11.9 7.8 18.9 7.3 7.1-.5 13.6-4.1 17.8-9.8l76.1-104.7c7.8-10.7 5.4-25.7-5.3-33.5s-25.7-5.4-33.5 5.3l-59.3 81.6-16.1-16.6c-9.2-9.5-24.4-9.8-33.9-.6-9.5 9.2-9.8 24.4-.6 33.9z', 'M99.5 449.2c.6 8.4 7.6 14.8 16 14.8l217.1 0c8.4 0 15.3-6.5 16-14.8l22.6-305.2 48.1 0-22.9 308.7c-2.5 33.4-30.3 59.3-63.8 59.3l-217.1 0c-33.5 0-61.4-25.9-63.8-59.3L28.8 144 76.9 144 99.5 449.2zM260.7 223.9c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5L223.4 356.8c-4.2 5.7-10.7 9.3-17.8 9.8-7.1 .5-14-2.2-18.9-7.3l-35.9-37.2c-9.2-9.5-8.9-24.7 .6-33.9 9.5-9.2 24.7-9 33.9 .6l16.1 16.6 59.3-81.6zM281.8-16c13.3 0 25.3 8.3 30 20.8L328 48 424 48c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 96C10.7 96 0 85.3 0 72S10.7 48 24 48l96 0 16.2-43.2c4.7-12.5 16.6-20.8 30-20.8l115.6 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrashCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;